module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main main1 update_trip_wrp",
    staticStyle: {
      "background-color": "white"
    }
  }, [(_vm.endTripModal) ? _c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('vue-form', {
    attrs: {
      "state": _vm.formstate
    }
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(" End Trip Reason")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.endTripReason),
    attrs: {
      "auto-label": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endTripReason),
      expression: "endTripReason"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "endTripReason",
      "maxlength": "200",
      "required": "",
      "placeholder": "End Trip Reason",
      "pattern": "[\\w\\W]{1,200}"
    },
    domProps: {
      "value": (_vm.endTripReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endTripReason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback validation_msg",
    attrs: {
      "name": "endTripReason",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                                End Trip Reason is a required field\n                                            ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                                Alphabets/Numbers/Special Characters are allowed.\n                                            ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    class: 'mr-2 btn gradientbt',
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.endTrips
    }
  }, [_vm._v("\n                                    End Trip\n                                ")]), _vm._v(" "), _c('button', {
    class: 'mr-5  btn btn-default',
    on: {
      "click": _vm.onCloseCDD
    }
  }, [_vm._v("\n                                    Cancel\n                                ")])])], 1)])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex justify-right trips_all_btns"
  }, [(_vm.details.tripStatus == 'Ongoing') ? _c('div', {
    staticClass: "addcollecction_wrp"
  }, [_c('button', {
    staticClass: "btn gradientbt",
    on: {
      "click": _vm.endTrip
    }
  }, [_vm._v("\n                    End Trip\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.details.tripStatus == 'Pending' || _vm.details.tripStatus == 'Upcoming') ? _c('div', {
    staticClass: "c-pointer delete_trip_btn"
  }, [(_vm.subCityAdmin) ? _c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.startTrip()
      }
    }
  }, [_vm._v("Start Trip")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.details.tripStatus == 'Pending' || _vm.details.tripStatus == 'Upcoming') ? _c('div', {
    staticClass: "c-pointer delete_trip_btn"
  }, [(_vm.subCityAdmin) ? _c('a', {
    staticStyle: {
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteTrip()
      }
    }
  }, [_vm._v("Delete Trip")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.details.tripStatus == 'Pending' || _vm.details.tripStatus == 'Upcoming') ? _c('div', {
    staticClass: "c-pointer update_primary_trip_btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateTrip()
      }
    }
  }, [_vm._v("Update Primary Trip")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_data_paddi"
  }, [_c('div', {
    staticClass: "shedule_date_data"
  }, [_c('div', {
    staticClass: "shedule_date_data_scroll"
  }, [_c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("City")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.cityId ? _vm.details.cityId.cityName : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Schedule Date and Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.scheduleTiming ? _vm.details.scheduleTiming : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Start Date and Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.tripstartTiming ? _vm.details.tripstartTiming : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip End Date and Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.tripEndTiming ? _vm.details.tripEndTiming : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Start Point")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.caId ? _vm.details.caId.areaName : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Driver")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.driverId ? _vm.details.driverId.firstName + ' ' + _vm.details.driverId.lastName :
    "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Helper")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.helperId ? _vm.details.helperId.firstName + ' ' + _vm.details.helperId.lastName : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Vehicle")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.vehicleId ? _vm.details.vehicleId.vNumber : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Houses")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.totalCount ? _vm.totalCount : "0"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Collected")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.collectedCount ? _vm.collectedCount : "0"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Not Collected")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.notCollectedCount ? _vm.notCollectedCount : "0"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Waste Collected (KG)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.totalWeight ? _vm.details.totalWeight : "0"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Status")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.tripStatus ? _vm.details.tripStatus : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Odometer Image")]), _vm._v(" "), _c('div', {
    staticClass: "viewPicture",
    style: ({
      cursor: 'pointer'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.odometerViewImage()
      }
    }
  }, [_c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    style: ({
      'pointer-events': _vm.details.startTripReadingURL == 'null' ||
        _vm.details.startTripReadingURL == null ||
        _vm.details.startTripReadingURL == '' ?
        'visible' :
        'none',
    }),
    attrs: {
      "role": "button",
      "title": "No Image Available"
    }
  }, [(_vm.details.startTripReadingURL != null && _vm.details.startTripReadingURL != 'null' && _vm.details.startTripReadingURL != '') ? _c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "role": "button"
    }
  }) : _vm._e(), _vm._v("\n                                " + _vm._s(_vm.details.startTripReadingURL == null || _vm.details.startTripReadingURL == 'null' ||
    _vm.details.startTripReadingURL == "" ? "--" : "") + "\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Selfies")]), _vm._v(" "), _c('div', {
    staticClass: "viewPicture",
    style: ({
      cursor: 'pointer'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selfiesViewImage()
      }
    }
  }, [_c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    style: ({
      'pointer-events': _vm.details.driverImageUrl == 'null' ||
        _vm.details.driverImageUrl == null ||
        _vm.details.driverImageUrl == '' ?
        'visible' :
        'none',
    }),
    attrs: {
      "role": "button",
      "title": "No Image Available"
    }
  }, [(_vm.details.driverImageUrl !== null && _vm.details.driverImageUrl !== 'null' && _vm.details.driverImageUrl !== '') ? _c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "role": "button"
    }
  }) : _vm._e(), _vm._v("\n                                " + _vm._s(_vm.details.driverImageUrl == null || _vm.details.driverImageUrl == "null" ||
    _vm.details.driverImageUrl == "" ? "--" : "") + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Odometer Start Reading (KM)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.startTripReading ? _vm.details.startTripReading : "0"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Odometer End Reading (KM)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.endTripReading ? _vm.details.endTripReading : "0"))])]), _vm._v(" "), (_vm.details.routeFileUri) ? _c('div', {
    staticClass: "area_inner"
  }, [_c('button', {
    staticClass: "view-houses",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.openRoutePopup
    }
  }, [_vm._v("View Route")])]) : _vm._e(), _vm._v(" "), (_vm.details.reason) ? _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip End Reason")]), _vm._v(" "), _c('a', {
    staticClass: "viewPicture c-pointer",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isReason = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "role": "button"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isImg) ? _c('div', {}, [_c('div', {
    staticClass: "overlay waste_type_pop"
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("\n                                        " + _vm._s(_vm.imgHeader) + "\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "img-wrapper"
  }, [(_vm.odometerImageUrl) ? _c('div', [_c('img', {
    staticClass: "odometer-img",
    attrs: {
      "src": _vm.odometerImageUrl
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.odometerImageUrl) ? _c('div', [_vm._v("\n                                            No Image Found\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    class: 'mr-5  btn btn-default',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isImg = false
      }
    }
  }, [_vm._v("\n                                            Cancel\n                                        ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isReason) ? _c('div', {}, [_c('div', {
    staticClass: "overlay waste_type_pop"
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("\n                                        Trip End Reason\n                                    ")]), _vm._v(" "), _c('h5', {
    staticClass: "reasonText"
  }, [_vm._v("\n                                        " + _vm._s(_vm.details.reason) + "\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    class: 'mr-5  btn btn-default',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isReason = false
      }
    }
  }, [_vm._v("\n                                            Cancel\n                                        ")])])])])])]) : _vm._e()])]), _vm._v(" "), (_vm.isMapActive) ? _c('div', {}, [_c('div', {
    staticClass: "location"
  }, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('div', {
    staticClass: "d-flex justify-right"
  }, [_c('button', {
    class: 'mr-5  btn btn-default close-button',
    on: {
      "click": _vm.onCloseMap
    }
  }, [_vm._v("\n                                        X\n                                    ")])]), _vm._v(" "), (_vm.houseLocation) ? _c('div', {
    staticClass: "map-show"
  }, [_c('multiLocation')], 1) : _vm._e(), _vm._v(" "), (!_vm.houseLocation) ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                                    No records Found\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-right"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isKmlShow) ? _c('div', {}, [_c('div', {
    staticClass: "location"
  }, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('div', {
    staticClass: "d-flex justify-right"
  }, [_c('button', {
    class: 'mr-5 btn btn-default close-button',
    on: {
      "click": _vm.onCloseMap
    }
  }, [_vm._v("\n                                        X\n                                    ")])]), _vm._v(" "), (_vm.isKmlShow) ? _c('div', {
    staticClass: "map-show"
  }, [_c('kmlView')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-right"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isMultipleLine) ? _c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('vue-form', {
    attrs: {
      "state": _vm.multipleFormstate
    }
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Mark Houses Collected for " + _vm._s(_vm.collectionDivisonName) + "\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 scroll_pop",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.multipleFormstate._id),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Lines")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "track-by": "_id",
      "label": "value",
      "options": _vm.multiplineData,
      "multiple": "",
      "name": "multiplineData",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.checkLine()
      }
    },
    model: {
      value: (_vm.multipleLine._id),
      callback: function($$v) {
        _vm.$set(_vm.multipleLine, "_id", $$v)
      },
      expression: "multipleLine._id"
    }
  })], 1), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "multiLine",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is a required field")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.multipleFormstate.startDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Collection Date and Time")]), _vm._v(" "), (!this.details.endTime) ? _c('datetime', {
    staticClass: "theme-wm",
    attrs: {
      "required": "",
      "id": "startDate",
      "type": "datetime",
      "min-datetime": new Date(this.details.startTime).toISOString(),
      "lang": "en",
      "name": "startDate",
      "input-class": "form-control",
      "placeholder": "Collection Date and Time"
    },
    on: {
      "input": function($event) {
        return _vm.checkDate()
      }
    },
    model: {
      value: (_vm.multipleLine.startDate),
      callback: function($$v) {
        _vm.$set(_vm.multipleLine, "startDate", $$v)
      },
      expression: "multipleLine.startDate"
    }
  }) : _vm._e(), _vm._v(" "), (this.details.endTime) ? _c('datetime', {
    staticClass: "theme-wm",
    attrs: {
      "required": "",
      "id": "startDate",
      "type": "datetime",
      "min-datetime": new Date(this.details.startTime).toISOString(),
      "max-datetime": new Date(this.details.endTime).toISOString(),
      "lang": "en",
      "name": "startDate",
      "input-class": "form-control",
      "placeholder": "Collection Date and Time"
    },
    on: {
      "input": function($event) {
        return _vm.checkDate()
      }
    },
    model: {
      value: (_vm.multipleLine.startDate),
      callback: function($$v) {
        _vm.$set(_vm.multipleLine, "startDate", $$v)
      },
      expression: "multipleLine.startDate"
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "startDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.isLineData && _vm.isDateData)
    },
    on: {
      "click": _vm.markLines
    }
  }, [_vm._v("\n                                            Done\n                                        ")]), _vm._v(" "), _c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onModalClose
    }
  }, [_vm._v("\n                                            Cancel\n                                        ")])])], 1)])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "collection_division_details_ssec collection_division_details_ssec_res"
  }, [_c('h3', [_vm._v("Collection Division Details")]), _vm._v(" "), _c('v-server-table', {
    ref: "collectionDetailsTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('div', {
          staticClass: "pointer"
        }, [_c('a', {
          staticClass: "fa fa-eye",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.action(props.row)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "pointer ml-20"
        }, [_c('a', {
          staticClass: "fa fa-home",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.viewHouseLocation(props.row._id)
            }
          }
        })]), _vm._v(" "), ((props.row.NotCollected !== 0)) ? _c('div', {
          staticClass: "pointer ml-20"
        }, [(_vm.details.tripStatus === 'Ongoing' || _vm.details.tripStatus === 'Complete') ? _c('a', {
          staticClass: "fa fa-check-square",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.gotoMultipleLinePopUp(props.row._id)
            }
          }
        }) : _vm._e()]) : _vm._e(), _vm._v(" "), ((props.row.NotCollected === 0)) ? _c('div', {
          staticClass: "pointer ml-20 disableEdit"
        }, [(_vm.details.tripStatus === 'Ongoing' || _vm.details.tripStatus === 'Complete') ? _c('a', {
          staticClass: "fa fa-check-square",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.gotoMultipleLinePopUp(props.row._id)
            }
          }
        }) : _vm._e()]) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2), _vm._v(" "), _c('div', {}, [_c('vue-easy-lightbox', {
    attrs: {
      "visible": _vm.visible,
      "imgs": _vm.imgs,
      "index": _vm.index
    },
    on: {
      "hide": _vm.handleHide
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-720ca40b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/primaryTrip/viewPrimaryTrip.vue
// module id = 2356
// module chunks = 1